import React, { Ref } from 'react';
import Highcharts from 'highcharts';
import { axisSettings, commonSettings } from '../charts.constants';
import { theme } from '../../../../theme/theme';
import { useChartSettings } from '../hooks/useChartSettings';
import { Chart } from '../Chart';
import { RefObjectForHighchartsReact } from '../Chart.types';

const chartSettings: Highcharts.Options = {
  ...commonSettings,

  chart: {
    type: 'spline',
  },

  credits: {
    enabled: false,
  },

  title: {
    text: '',
  },

  xAxis: {
    ...commonSettings.xAxis,
    labels: {
      step: 5,
      staggerLines: 1,
      style: {
        fontSize: `${theme.fontSizes.small}px`,
        color: theme.colors.neutral['500'],
        fontWeight: '500',
      },
    },
  },

  yAxis: {
    ...commonSettings.yAxis,
    min: 0,
    stackLabels: {
      enabled: false,
    },
    labels: {
      style: {
        fontFamily: theme.fontFamily,
        fontSize: `${theme.fontSizes.small}px`,
        color: theme.colors.neutral['500'],
        fontWeight: '500',
      },
      ...axisSettings.currency.labels,
    },
  },

  legend: {
    enabled: false,
  },

  plotOptions: {
    spline: {
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false,
          },
        },
      },
    },
  },

  tooltip: commonSettings.tooltip,
};

export interface SplineChartSeries {
  name: string;
  data: number[];
  color: string;
}

interface AreaSplineChartProps {
  series: SplineChartSeries[];
  categories: string[];
  customSettings?: Record<string, any>;
  innerRef?: Ref<RefObjectForHighchartsReact>;
}

export const SplineChart = React.forwardRef<RefObjectForHighchartsReact, AreaSplineChartProps>(
  (props, ref) => {
    const { series, categories, customSettings = {} } = props;

    const settings = useChartSettings({
      series,

      settings: {
        ...chartSettings,
        xAxis: {
          ...chartSettings.xAxis,
          categories,
        },

        tooltip: {
          ...chartSettings.tooltip,
        },
      },
      customSettings,
    });

    return <Chart options={settings} ref={ref} />;
  },
);
